import { SplitButton, WithBoundaryBridge } from "@pjs/core-ui";
import { react2angular } from "@pebblepad/react2angular";
import { angularAMD } from "@pebblepad/amd";

angularAMD.component(
    "splitButtonComponent",
    react2angular(WithBoundaryBridge(SplitButton), [
        "onClick",
        "selectOptions",
        "children",
        "disabled",
        "buttonDataHook",
        "buttonMenuDataHook",
        "dropdownLabel",
        "buttonLabel"
    ])
);
